import React, {Component} from 'react'
import SwiperCore, {A11y, Autoplay} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/swiper-bundle.css';
import './message.css'
import {post} from "../common/utils/http";
import {LogoutOutlined, MailTwoTone} from '@ant-design/icons';
import {Button, Modal} from 'antd';
import MessageSysContent from './messageSysContent'
import {commonLan, getLanguage} from "../source/js/common";

SwiperCore.use([Autoplay, A11y]);
const messageLan = require('../constant/js/formItemNameLabel/'+getLanguage()+'/message.js');

class messageSwiper extends Component {
    state = {
        getNoticelist: [], //消息列表
        getUserUnreadMsgNum: "", //消息数量
        visible: false,  //单个消息展示的弹窗
        visible1: false, //消息系统的弹窗
        messageContent: ``, //单个消息的内容信息
        getList:{get:false,code:""},
        messageSent:null
    }
    componentDidMount() {
        this.handleGetUserUnreadMsgNum()
    }
    handleGetUserUnreadMsgNum(){
        // 下边是请求消息数量的接口 赋值
        post("aos/mainui/notice/getUserUnreadMsgNum").then(res => {
            this.setState({
                getUserUnreadMsgNum: res.noticenum
            })
        })
        // 下边是请求消息列表的接口 赋值
        post("aisino/portalIndex/getNoticeListForSwiper").then(res => {
            this.setState({
                getNoticelist: res
            })
        })
    }
    componentWillReceiveProps(nextPorops){
        return true
    }
    // 控制消息系统弹窗弹出的函数
    showModalSys() {
        this.setState({
            visible1: true,
        });
    };
    //关闭消息系统弹窗的函数
    handleCancelSys = e => {
        this.setState({
            visible1: false,
        });
    };

    //==================================================================================================  分割

    // 控制单个消息弹窗弹出的函数
    showModal = (data) => {
        post("aisino/portalIndex/getNoticeById",{
            cguid: data.cguid
        }).then(dataRes=>{
            if(dataRes){
                this.setState({
                    visible: true,
                    messageContent: dataRes,
                });
                post("/notice/aos/notice/noticelist/setIstatus",{
                    cguid: data.cguid
                }).then(res=>{
                    post("aos/mainui/notice/getUserUnreadMsgNum").then(res => {
                        this.setState({
                            getUserUnreadMsgNum: res.noticenum
                        })
                    })
                    post("aisino/portalIndex/getNoticeListForSwiper").then(res => {
                        this.setState({
                            getNoticelist: res
                        })
                    })
                })
            }
        })
    };
    //关闭单个消息弹窗的函数
    handleCancel = e => {
        // console.log(e);
        this.setState({
            visible: false,
        });
    };
    render() {
        // 下边是单个消息轮播的样式
        let textHidden = {
            width: "100%",
            wordBreak: "keep-all",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            font: "bold 10px Verdana",
            marginTop:"2px"
        }
        // 下边是点击进入消息系统的按钮样式
        let message = {
            fontSize: "16px",
            fontWeight: "bold",
            display: "inline-block",
            height: "35px",
            lineHeight: "35px",
            padding: "0 0 0 20px" ,
            position: "relative",
        }
        // 下边是消息数量的样式
        let messagesNum = {
            position: "absolute",
            top:"-5.5px",
            left:"33px",
            fontSize:"10px",
            color:"#fff",
            width:"24px",
            textAlign:"center"
        }
        // 下边是用css属性制作一个红色实心的圆
        let redCircle = {
            border:"11px #FF0000 solid",
            borderRadius:"50%",
            display: "inline-block",
            position: "absolute",
            top:0,
            left:"33px",
            width:"12px",
            textAlign: "center"

        }
        // 下边是轮播列表赋值到List中
        let List = this.state.getNoticelist.map((item, index) => {
            return (
                <SwiperSlide className={"messageMouse"} onClick={() => this.showModal(item)} key={item.cguid}>
                    <p style={textHidden}>{(index + 1) + ". " + item.name}</p>
                </SwiperSlide>
            )
        })
        return (
            <div style={{ background: "#fff" ,height:"37px"}} className="messageSwiper">
                {/* 下边是消息系统的点击按钮 */}
                <span className={"messageMouse"} style={message} onClick={()=>this.showModalSys()}>
                    <MailTwoTone  style={{ fontSize: "24px" ,position: "relative",top: "3px"}} />
                    <span style={{fontSize:"14px",fontWeight:"bold"}}>&nbsp;&nbsp; {messageLan.messagesButton.label}</span>
                    {this.state.getNoticelist.length === 0 ?"":<i style={redCircle}></i>}
                    {this.state.getNoticelist.length === 0 ?"":<span style={messagesNum}>{this.state.getUserUnreadMsgNum>100?"99+":this.state.getUserUnreadMsgNum}</span>}
                </span>
                {/* 下边是轮播效果 */}
                <Swiper
                    style={{ margin: "-25px 0px 0px 145px", padding: "0 20px 0 0" ,width:"1188px"}}
                    autoplay={{ autoplay: true, waitForTransition: false, disableOnInteraction: false }}
                    spaceBetween={50}
                    slidesPerView={4}
                    onSwiper={(swiper) => swiper}
                >
                    {this.state.getNoticelist.length === 0 ? "":List}
                </Swiper>
                {/* 下边是单个消息点击的弹窗 */}
                <Modal
                    className="messageConversation"
                    title={messageLan.messageConversation.label}
                    width={1280}
                    style={{ top: 30 }}
                    footer={null}
                    maskClosable={false}
                    bodyStyle={{padding:"0 50px",height:"650px",overflow:"auto"}}
                    maskStyle={{ background: "rgba(255,255,255,0.7)" }}
                    visible={this.state.visible}
                    onCancel={this.handleCancel}
                >
                    {/* 下边是后台返回的消息内容渲染到页面 */}
                    {this.state.messageSent?
                        <Button style={{borderRadius:"4px", margin: "3px 0"}} type="text" onClick={() => { this.setState({visible:false}) }}><LogoutOutlined />{commonLan.closeButton.label}</Button>
                        :""}
                    {this.state.messageSent?<div style={{borderBottom:"1px #ccc solid",width:"100%"}}></div>:""}
                    {this.state.messageSent?<p style={{color:"#10965f",fontWeight:"bold",fontSize:"12px",paddingLeft:"10px"}}>
                        Receiver:{this.state.messageSent.ctousernames}
                    </p>:""}
                    {this.state.messageSent?<span style={{color:"#10965f",fontFamily:"sans-serif",fontSize:"12px",paddingLeft:"13px"}}>
                        {this.state.messageSent.cfromusername}:
                    </span>:""}
                    {this.state.messageSent?
                        <div style={{display:"inline-block"}} dangerouslySetInnerHTML={{ __html: this.state.messageSent.cdesc }}/>
                        :
                        <div style={{display:"inline-block"}} dangerouslySetInnerHTML={{ __html: this.state.messageContent.content }} />
                    }
                    {this.state.messageSent?<div style={{paddingLeft:"10px"}}>
                        {this.state.messageSent.dcreatedate}
                    </div>:""}
                    {this.state.messageSent?<div style={{borderBottom:"1px #ccc dashed",width:"100%"}}></div>:""}
                </Modal>
                {/* 下边是消息系统的点击弹窗 */}
                <div id="messageModal">
                    <Modal
                        className="messageConversation"
                        title={messageLan.message.label}
                        width={1280}
                        bodyStyle={{padding:"0 50px",height:"600px"}}
                        style={{ top: 30 }}
                        footer={null}
                        maskClosable={false}
                        getContainer={window.document.getElementById("messageModal")}
                        maskStyle={{ background: "rgba(255,255,255,0.7)" }}
                        visible={this.state.visible1}
                        onCancel={this.handleCancelSys}
                        forceRender={true}
                        destroyOnClose={true}
                    >
                        <MessageSysContent
                            noticenum={this.state.getUserUnreadMsgNum}
                            getList={this.state.getList}
                            handleExit={this.handleCancelSys.bind(this)}
                            handleMsgNum={this.handleGetUserUnreadMsgNum.bind(this)}
                            handleView={this.handleData.bind(this)}
                            getList1={()=>{this.setState({
                                getList:{get:false,code:""}
                            })}}
                        />
                    </Modal>
                </div>

            </div>

        )
    }
    handleData(data,item){
        if(item === "000001"){
            post("/notice/aos/notice/noticelist/getNoticeView",{
                "cguid":data.cguid,
                "creplyguid":"",
                "cfromuserguid":"",
                "ctouserguid":"",
                "issender":"1"
            }).then(res=>{
                this.setState({
                    visible: true,
                    messageSent: res[0],
                });
            })
        }else{
            this.setState({
                messageSent: null,
                visible: true,
                messageContent: data,
            });
            post("/notice/aos/notice/noticelist/setIstatus",{
                cguid: data.cguid
            }).then(res=>{
                post("aos/mainui/notice/getUserUnreadMsgNum").then(res => {
                    this.setState({
                        getUserUnreadMsgNum: res.noticenum
                    })
                })
                this.setState({
                    getList:{get:true,code:item}
                })
            })
        }

    }
}
export default messageSwiper